import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';
import { LayoutWrapper } from '@/components/layout-wrapper';
import { StoreInitializer } from '@/components/StoreInitializer';

export function RootLayout() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <StoreInitializer />
      <LayoutWrapper>
        <Outlet />
      </LayoutWrapper>
    </ThemeProvider>
  );
}
